export const setTeamStoreData = (teamStoreData: object) => dispatch => {
    dispatch({ type: 'SET_TEAM_STORE_DATA', payload: teamStoreData });
};
